import { useState } from "react";
import { Modal } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import "modules/CommunicationTemplates/components/DuplicateMediumModal/DuplicateMediumModal.scss";
import { DuplicateMediumModalForm } from "modules/CommunicationTemplates/components/DuplicateMediumModal/DuplicateMediumModalForm";
import { useDuplicateMediumMutation } from "modules/CommunicationTemplates/hooks";

import type { CommunicationMedium } from "models";

type DuplicateMediumModalProps = {
  medium: CommunicationMedium | null;
  onClose: () => void;
  onExpandDuplicatedMedium: () => void;
};

export type DuplicateMediumFormValues = Pick<CommunicationMedium, "communication_medium_id" | "car_brand" | "car_model">;

const FormHelper = createFormHelper<DuplicateMediumFormValues>();

export const DuplicateMediumModal = ({ onClose, onExpandDuplicatedMedium, medium }: DuplicateMediumModalProps) => {
  const [hasErrors, setHasErrors] = useState(false);

  const { mutateAsync: duplicateMedium, isPending: isDuplicateMediumPending } = useDuplicateMediumMutation();

  if (!medium) return;

  const handleClose = () => {
    onClose();
    setHasErrors(false);
  };

  const validateFormData = (values: DuplicateMediumFormValues) => {
    const hasErrors = !values.communication_medium_id || !values.car_brand;
    setHasErrors(hasErrors);
    return !hasErrors;
  };

  const handleSubmit = async (fields: DuplicateMediumFormValues) => {
    if (!validateFormData(fields)) return;

    await duplicateMedium({ ...medium, ...fields });
    onExpandDuplicatedMedium();
    handleClose();
  };

  return (
    <Modal open={true} size="large">
      <FormHelper.Form
        onSubmit={handleSubmit}
        defaultValues={{
          communication_medium_id: medium.communication_medium_id,
          car_brand: medium.car_brand,
          car_model: medium.car_model
        }}
      >
        <div className="DuplicateMediumModal">
          <DuplicateMediumModalForm
            hasErrors={hasErrors}
            onClose={handleClose}
            onSubmit={handleSubmit}
            medium={medium}
            isDuplicateMediumPending={isDuplicateMediumPending}
          />
        </div>
      </FormHelper.Form>
    </Modal>
  );
};
